import { Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

function OptimizeToggle({ enabled, onToggle }) {
  return (
    <div className="mt-3 flex items-center gap-3 pl-1">
      <button
        data-testid="optimize-min-trucks-toggle"
        type="button"
        role="switch"
        aria-checked={enabled}
        onClick={onToggle}
        className={
          "relative w-9 h-5 rounded-full transition-colors " +
          (enabled ? "bg-[#2563EB]" : "bg-white/20")
        }
      >
        <span
          className={
            "absolute top-0.5 w-4 h-4 rounded-full bg-black transition-all " +
            (enabled ? "left-4" : "left-0.5")
          }
        />
      </button>
      <div className="mono text-[11px] text-[#64748B]">
        <span className="text-white/90 uppercase tracking-widest">Optimize for min trucks</span>
        <span className="ml-2 text-[#64748B]">
          {enabled
            ? "· heavy + light packed together (fewer trucks, may need crane for mixed load)"
            : "· heavy (>1000 kg) & light cargo split into separate trucks"}
        </span>
      </div>
    </div>
  );
}

export default function CalculateBar({
  jobName,
  onJobNameChange,
  onCalculate,
  calculating,
  optimizeMinTrucks,
  onToggleOptimize,
}) {
  return (
    <section className="mb-10 fade-up">
      <div className="bg-[#F8FAFC] border border-slate-200 p-5 flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <div className="flex items-center gap-3">
          <Calculator className="w-5 h-5 text-[#2563EB]" />
          <div>
            <label className="overline block mb-1">Job Name</label>
            <Input
              data-testid="job-name-input"
              value={jobName}
              onChange={(e) => onJobNameChange(e.target.value)}
              placeholder="e.g. AIDA Press Machine — Chennai"
              className="bg-[#FFFFFF] border-slate-200 rounded-none focus:ring-1 focus:ring-[#2563EB] focus:border-[#2563EB] w-full md:w-96 mono text-sm"
            />
          </div>
        </div>
        <Button
          data-testid="calculate-load-btn"
          onClick={onCalculate}
          disabled={calculating}
          className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-md font-semibold px-8 py-6 mono uppercase tracking-widest text-xs transition-colors duration-200"
        >
          {calculating ? "Calculating…" : "Calculate Load Plan →"}
        </Button>
      </div>
      <OptimizeToggle enabled={optimizeMinTrucks} onToggle={onToggleOptimize} />
    </section>
  );
}
